export class InvariantViolation {
  public readonly type: "InvariantViolation" = "InvariantViolation" as const;
  constructor(readonly message: string) {}
}

export class FetchException {
  public readonly type: "FetchException" = "FetchException" as const;
  constructor(readonly message: string) {}
}
